module.exports = __webpack_public_path__ + "img/cond_pag_invoiceweb.55b76a87.png";